/**
 * Step 03 graphic: a revenue chart climbing, ending on an ON AUTOPILOT badge.
 * Ported from GrowGraphic.dc.html.
 *
 * The figures here are illustrative, not any client's data. It is decorative
 * and hidden from assistive tech so nothing reads it out as a real statistic --
 * the real, attributed numbers live in the stat band further down the page.
 */
const bars = [
  { height: '26%', fill: 'var(--ink-200)', delay: '.1s' },
  { height: '38%', fill: 'var(--ink-200)', delay: '.24s' },
  { height: '34%', fill: 'var(--ink-200)', delay: '.38s' },
  { height: '56%', fill: 'var(--bw-yellow)', delay: '.52s' },
  { height: '72%', fill: 'var(--bw-yellow)', delay: '.66s' },
  { height: '96%', fill: 'var(--bw-yellow)', delay: '.8s' },
];

const months = ['MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG'];

export function GrowGraphic() {
  return (
    <div
      aria-hidden="true"
      className="flex h-full w-full items-center justify-center p-3.5"
    >
      <div
        style={{
          width: '100%',
          maxWidth: 400,
          border: '2px solid var(--bw-ink)',
          borderRadius: 12,
          background: '#fff',
          boxShadow: '4px 4px 0 var(--bw-ink)',
          padding: 16,
          boxSizing: 'border-box',
          position: 'relative',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'baseline',
            gap: 8,
            marginBottom: 12,
          }}
        >
          <span
            style={{
              font: '600 8px/1 var(--font-body)',
              letterSpacing: '.14em',
              textTransform: 'uppercase',
              color: 'var(--text-muted)',
            }}
          >
            Revenue · last 6 months
          </span>
          <span
            style={{
              marginLeft: 'auto',
              font: '800 15px/1 var(--font-display)',
              color: 'var(--bw-ink)',
              animation: 'hiw-rise .4s var(--ease-bounce) both 1.5s',
            }}
          >
            +34%
          </span>
        </div>

        <div
          style={{
            position: 'relative',
            height: 152,
            display: 'flex',
            alignItems: 'flex-end',
            gap: 10,
            borderBottom: '2px solid var(--bw-ink)',
          }}
        >
          {bars.map((bar, i) => (
            <div
              key={i}
              style={{
                flex: 1,
                height: bar.height,
                border: '2px solid var(--bw-ink)',
                borderBottom: 0,
                borderRadius: '5px 5px 0 0',
                background: bar.fill,
                transformOrigin: 'bottom',
                animation: `hiw-bar .55s var(--ease-out) both ${bar.delay}`,
              }}
            />
          ))}
          <svg
            viewBox="0 0 260 120"
            preserveAspectRatio="none"
            style={{
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
              overflow: 'visible',
            }}
          >
            <path
              d="M18 92 L60 78 L102 82 L144 56 L186 36 L228 10"
              fill="none"
              stroke="#000"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeDasharray="260"
              style={{ animation: 'hiw-draw .9s ease-in-out both 1s' }}
            />
          </svg>
        </div>

        <div style={{ display: 'flex', gap: 10, marginTop: 7 }}>
          {months.map((month) => (
            <span
              key={month}
              style={{
                flex: 1,
                textAlign: 'center',
                font: '600 8px/1 var(--font-body)',
                color: 'var(--text-muted)',
              }}
            >
              {month}
            </span>
          ))}
        </div>

        <div
          style={{
            position: 'absolute',
            right: -12,
            top: -12,
            padding: '6px 11px',
            border: '2px solid var(--bw-ink)',
            borderRadius: 999,
            background: 'var(--bw-yellow)',
            boxShadow: '3px 3px 0 var(--bw-ink)',
            font: '800 9px/1 var(--font-display)',
            letterSpacing: '.1em',
            color: 'var(--bw-ink)',
            animation: 'hiw-ggpop .5s var(--ease-bounce) both 1.7s',
          }}
        >
          ON AUTOPILOT
        </div>
      </div>
    </div>
  );
}
